import { useEffect } from "react";
import { getAuthData, getSessinIdFromLS } from "../../services/storage/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { setDomainState } from "../../state/actions/domain";
import SpinnetView from "../../components/common/SpinnetView";
import { appType } from "../../utils/config/configHelpers";
import { createConversationId } from "../../utils/conversationUtils";

import config from "../../utils/config/config";
import HomeComponent from "./components/homeComponent";
import FMConversationalBot from "../../components/tabs/FMConversationalBot";


const Home = () => {
  const { selectedBotId, selectedBotDetails, defaultHomePageBotId } = useSelector((state) => state.domain);
  const botWaitLoader = useSelector((state) => state.loader.botWaitLoader);
  const userDetail = getAuthData();
  const userData = userDetail.user || {}
  const selectedConversation = useSelector((state) => state.chats.selectedConversation);
  const selectedDomain = useSelector((state) => state.domain.selectedDomain);
  const isDefaultHomePageBot = useSelector((state) => state.bot.isDefaultHomePageBot);
  const isAssistantBotOpen = useSelector((state) => state.bot.isAssistantBotOpen);
  const domainList = useSelector((state) => state?.domain?.domains);
  const botSubscriptions = useSelector((state) => state?.user?.botSubscriptions);
  const refreshToken = localStorage.getItem("refreshToken");
  const connectionId = localStorage.getItem("connectionId");
  const dispatch = useDispatch();
  const sessionId = getSessinIdFromLS();

  useEffect(() => {
    if (userDetail && Object.keys(userDetail).length > 0 && domainList.length === 0) {
      dispatch(setDomainState(true));
    }
  }, []);
  
  // if (
  //   selectedDomain &&
  //   ((selectedConversation && selectedBotDetails?.customFrontEnd) || isDefaultHomePageBot)
  // ) {
  //   return (
  //     <SpinnetView
  //       baseUrl={isDefaultHomePageBot ? config.defaultHomePagebaseUrl : selectedBotDetails.customFrontEnd}
  //       botId={isDefaultHomePageBot ? defaultHomePageBotId : selectedBotId}
  //       email={userData?.emailAddress}
  //       mobileSession={sessionId || userDetail?.auth?.sessionId}
  //       appType={appType}
  //       platform="web"
  //       conversationId={
  //         isDefaultHomePageBot
  //           ? defaultHomePageBotId
  //             ? createConversationId(userData.userId, defaultHomePageBotId)
  //             : ""
  //           : selectedConversation.conversationId
  //       }
  //       userDomain={selectedDomain}
  //       refreshToken={refreshToken}
  //       connectionId={connectionId}
  //       isLoading={botWaitLoader}
  //       isDefaultHomePageBot={isDefaultHomePageBot}
  //       botSubscriptions={botSubscriptions}
  //     />
  //   );
  // }

  if (selectedBotDetails?.conversational || selectedBotDetails?.systemBot || isAssistantBotOpen) {
    return <FMConversationalBot
        refreshToken={refreshToken}
        connectionId={connectionId}
    />
  }

  return <HomeComponent isLoading={botWaitLoader} refreshToken={refreshToken}
        connectionId={connectionId} />
};

export default Home;